import { Link, useParams } from "react-router-dom";
import useGetData from "../../../hook/getData";
import { GetBlogs, GetlatestBlog, GetBlog } from "../../../services/client/blog/getBlogCategories";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/pagination';
import { BlogsSettings } from "../../../features/swiperOptions/swiperOptions";
import { IconCalendar, IconChevronLeft } from "@tabler/icons-react";

const CategoryDetail = () => {

    const { slug } = useParams();

    const { data: blogDetail, isLoading: detailLoading } = useGetData(
        ['blog-detail', slug],
        () => GetBlog(slug || "")
    );

    const { data: latestBlog } = useGetData(['latest-blog'], GetlatestBlog);

    const { data: blogs } = useGetData(['blogs'], GetBlogs);


    if (detailLoading) {
        return (
            <div className="container h-100 mt-5">
                <div className="row h-100 justify-content-center py-5 align-items-center">
                    <div className="col-md-6 text-center">
                        <img alt="logo" className="acband-price-icon animate-logo" src={require('./../../../assets/media/logo/final.png')} />
                        <p className="fw-bold mt-3">
                            در حال بارگذاری..
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <section className="bg-white py-md-5 py-4">
                <div className="container">
                    <div className="row gy-4">

                        <div className="col-lg-8">
                            <div className="card card-body border-0 rounded-4 shadow">

                                <h1 className="fw-bold h5">{blogDetail?.post?.title}</h1>

                                <div className="d-flex align-items-center justify-content-between mt-3">
                                    <div className="d-flex align-items-center">
                                        <img alt="logo" className="img-fluid logo-admin-blog" src={require('./../../../assets/media/logo/final.png')} />
                                        <div className="ms-2">
                                            <p className="font-medium mb-1">ادمین آریا استیل</p>
                                            <p className="mb-0 font-medium text-muted">
                                                {blogDetail?.post?.categories?.map((c: any) => c.name).join("، ")}
                                            </p>
                                        </div>
                                    </div>
                                    <span className='font-medium text-muted'>
                                        <IconCalendar size={14} className="me-1" />
                                        اردیبهشت 1405
                                    </span>
                                </div>



                                <img
                                    src={`https://admin.ariyasteelrad.ir/uploads/files/blog/posts/${blogDetail?.post?.image}`}
                                    alt={blogDetail?.post?.title}
                                    className="blog-detail-img rounded-4 my-3 mt-4"
                                />

                                <div
                                    className="blog-content line-30 text-justify"
                                    dangerouslySetInnerHTML={{ __html: blogDetail?.post?.content }}
                                />

                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="card product-swicher position-sticky card-body border-0 rounded-4 shadow">
                                <h6 className="fw-bold font-medium-lg mb-3">آخرین وبلاگ ها</h6>

                                {latestBlog?.data?.map((item: any, index: number) => (
                                    index > 0 && index < 5 && (
                                        <Link key={item.id} className='text-decoration-none mb-3' to={`/blog/detail/${item.slug}`}>
                                            <div className='card card-body border-0 border-bottom'>
                                                <div className='d-flex align-items-center'>
                                                    <img
                                                        src={`https://admin.ariyasteelrad.ir/uploads/files/blog/posts/${item.image}`}
                                                        alt="blog"
                                                        className="img-detail-blog"
                                                    />
                                                    <div className="ms-3 w-100">
                                                        <div className='blog-toggle'>
                                                            {item?.categories[0]?.name}
                                                        </div>
                                                        <p className='card-text text-black overflow-hidden mb-0 mt-3'>
                                                            {item.title}
                                                        </p>
                                                        <div className='d-flex justify-content-between mt-3'>
                                                            <p className='text-muted font-medium mb-0'>ادمین استیرا</p>
                                                            <span className='font-medium text-muted'>اردیبهشت 1405</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    )
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </section>


            <section className="bg-white py-3 pb-3">
                <div className="container">
                    <div className="d-flex justify-content-between mb-3 align-items-center">
                        <h6 className="fw-bold h5 mb-0">وبلاگ ها</h6>
                        <Link className='font-medium-lg text-site text-decoration-none' to='/blog/categories/all'>
                            مشاهده همه <IconChevronLeft size={16} />
                        </Link>
                    </div>

                    <div className="new-products">
                        {blogs?.posts ? (
                            <Swiper {...BlogsSettings}>
                                {blogs?.posts?.data?.reverse().map((blog: any) => (
                                    <SwiperSlide key={blog.id + 'blogs'}>
                                        <Link key={blog.id} className='text-decoration-none mb-3' to={`/blog/detail/${blog.slug}`}>
                                            <div className='card rounded rounded-4 border-0 shadow-sm card-body blog-item-card'>
                                                <div className='card-image'>
                                                    <img
                                                        src={`https://admin.ariyasteelrad.ir/uploads/files/blog/posts/${blog.image}`}
                                                        alt=""
                                                    />
                                                </div>
                                                <div className='card-items mt-3'>
                                                    <div className='blog-toggle'>
                                                        {blog?.categories[0]?.name}
                                                    </div>
                                                    <h6 className='fw-bold line-25 text-split font-medium-lg mt-3'>
                                                        {blog.title}
                                                    </h6>
                                                    <div className='d-flex justify-content-between mt-3'>
                                                        <p className='text-muted font-medium mb-0'>ادمین استیرا</p>
                                                        <span className='font-medium text-muted'>اردیبهشت 1405</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        ) : null}
                    </div>

                </div>
            </section>
        </>
    );
};

export default CategoryDetail;
